import { render, staticRenderFns } from "./TnyLobbyEvolutionFooter.vue?vue&type=template&id=5ed47586&"
import script from "./TnyLobbyEvolutionFooter.vue?vue&type=script&lang=ts&"
export * from "./TnyLobbyEvolutionFooter.vue?vue&type=script&lang=ts&"
import style0 from "./TnyLobbyEvolutionFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports